import { queryKey } from '../constants/queryClientKey';
import { getPatientsVisited, resetPasswordPatient } from '../apis/patient.api';
import { sortObjectKeys } from '@vindr/utils/helpers/common.helper';
import {
  UseQueryOptions,
  UseQueryResult,
  useMutation,
  useQuery,
  useQueryClient,
} from '@tanstack/react-query';

export function useGetPatientsVisited(
  params: Parameters<typeof getPatientsVisited>[0],
  options?: UseQueryOptions
) {
  return useQuery(
    [queryKey.visited_patients, sortObjectKeys(params)],
    () => getPatientsVisited(params),
    options
  ) as UseQueryResult<Awaited<ReturnType<typeof getPatientsVisited>>>;
}

/* export function useCreatePatient() {
  const queryClient = useQueryClient();

  return useMutation(async (params: Parameters<typeof createPatient>[0]) => createPatient(params), {
    onSuccess: () => {
      queryClient.invalidateQueries([queryKey.visited_patients]);
    },
    onError: (err) => {
      console.error('useCreatePatient', err);
    },
  });
} */

/* export function useUpdatePatient() {
  const queryClient = useQueryClient();

  return useMutation(
    async ({ id, data }: { id: string; data: Parameters<typeof updatePatient>[0] }) =>
      updatePatient(id, data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([queryKey.visited_patients]);
      },
      onError: (err) => {
        console.error('useUpdatePatient', err);
      },
    }
  );
}
 */
/* export function useDeletePatient() {
  const queryClient = useQueryClient();

  return useMutation(async (id: string) => deletePatient(id), {
    onSuccess: () => {
      queryClient.invalidateQueries([queryKey.visited_patients]);
    },
    onError: (err) => {
      console.error('useDeletePatient', err);
    },
  });
} */

export function useResetPasswordPatient() {
  const queryClient = useQueryClient();

  return useMutation(async (id: string) => resetPasswordPatient(id), {
    onSuccess: () => {
      queryClient.invalidateQueries([queryKey.visited_patients]);
    },
    onError: (err) => {
      console.error('useResetPasswordPatient', err);
    },
  });
}
